import { connect } from 'react-redux'
import { makeSelectPresenceByMemberId } from 'ducks/chat/selectors/presence'
import {
  selectMemberNameFromProps,
  selectMemberUserIdFromProps,
  selectMemberAvatarUrlFromProps,
} from 'ducks/chat/selectors/users'
import MemberAvatarView from './view'

const select = () => {
  const selectPresenceByMemberId = makeSelectPresenceByMemberId()
  return (state, props) => {
    return {
      presence: selectPresenceByMemberId(state, props),
      name: selectMemberNameFromProps(state, props),
      userId: selectMemberUserIdFromProps(state, props),
      avatarUrl: selectMemberAvatarUrlFromProps(state, props),
    }
  }
}

export default connect(select)(MemberAvatarView)
